// extracted by mini-css-extract-plugin
export default {"container":"o_-z","productName":"p_-z","price":"q_-z","dimensions":"r_-z"};